// extracted by mini-css-extract-plugin
export default {"tableContainer":"page-table-container_tableContainer__qbCY7"};